var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarChartActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.9082,
    y: 7.23218,
    width: 4.44312,
    height: 16.4054,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.708,
    y: 14.0645,
    width: 4.09398,
    height: 9.57314,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.25635,
    y: 17.9714,
    width: 4.14853,
    height: 5.66606,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5345 23.0626H22.5064V8.1346C22.5064 7.43978 21.9411 6.87451 21.2463 6.87451H18.9483C18.2534 6.87451 17.6882 7.43982 17.6882 8.1346V23.0626H15.0776V14.8982C15.0776 14.2033 14.5124 13.6381 13.8175 13.6381H11.5195C10.8247 13.6381 10.2594 14.2034 10.2594 14.8982V23.0626H7.64887V18.8343C7.64887 18.1395 7.08355 17.5742 6.38877 17.5742H4.09073C3.3959 17.5742 2.83063 18.1395 2.83063 18.8343V23.0626H1.74707C1.48818 23.0626 1.27832 23.2725 1.27832 23.5314C1.27832 23.7902 1.48818 24.0001 1.74707 24.0001H23.5345C23.7934 24.0001 24.0032 23.7902 24.0032 23.5314C24.0032 23.2725 23.7934 23.0626 23.5345 23.0626ZM6.71127 23.0626H3.76809V18.8343C3.76809 18.6564 3.91279 18.5117 4.09068 18.5117H6.38868C6.56657 18.5117 6.71127 18.6564 6.71127 18.8343V23.0626ZM14.1401 23.0626H11.1969V14.8982C11.1969 14.7203 11.3416 14.5756 11.5195 14.5756H13.8175C13.9953 14.5756 14.1401 14.7203 14.1401 14.8982V23.0626ZM21.5689 23.0626H18.6257V8.1346C18.6257 7.95671 18.7704 7.81201 18.9483 7.81201H21.2463C21.4242 7.81201 21.5689 7.95671 21.5689 8.1346V23.0626Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.505 0.492938C22.5115 0.365016 22.4665 0.234938 22.3689 0.13725C22.2712 0.0395625 22.1411 -0.00548438 22.0132 0.001125C22.0056 0.000796875 21.9982 0 21.9905 0H19.1545C18.8956 0 18.6858 0.209859 18.6858 0.46875C18.6858 0.727641 18.8956 0.9375 19.1545 0.9375H20.9056L16.2717 5.57147L14.5242 3.82397C14.4363 3.73608 14.3171 3.68667 14.1928 3.68667C14.0685 3.68667 13.9492 3.73608 13.8613 3.82397L5.43465 12.2507C5.2516 12.4337 5.2516 12.7305 5.43465 12.9136C5.5262 13.0051 5.64615 13.0508 5.7661 13.0508C5.88605 13.0508 6.00605 13.0051 6.09755 12.9135L14.1928 4.81828L15.9403 6.56578C16.1233 6.74883 16.4201 6.74883 16.6032 6.56578L21.5686 1.60045V3.1853C21.5686 3.44419 21.7785 3.65405 22.0374 3.65405C22.2962 3.65405 22.5061 3.44419 22.5061 3.1853V0.515625C22.5061 0.507984 22.5053 0.500531 22.505 0.492938Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.18604 14.6863C4.44492 14.6863 4.65479 14.4764 4.65479 14.2175C4.65479 13.9586 4.44492 13.7488 4.18604 13.7488C3.92715 13.7488 3.71729 13.9586 3.71729 14.2175C3.71729 14.4764 3.92715 14.6863 4.18604 14.6863Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.640625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartActive);
export default __webpack_public_path__ + "static/media/bar-chart-active.1685c9597223877ed20110e16e50b14b.svg";
export { ForwardRef as ReactComponent };